<template>
  <div
    class="offer-card"
    :class="offer.isArchived ? 'expired-offer' : ''"
  >
    <div
      v-if="offer.is_internship"
      class="internship-cap"
    >
      <font-awesome-icon icon="graduation-cap" />
    </div>
    <div class="card-wrapper row flex-wrap">
      <div class="col-12 col-md-2 column">
        <h1
          class="title"
          style="font-size: 0.9rem !important;"
          @click.stop="$router.push({ path: '/jobs/offer/' + offer.id + '/' + generateSlug })"
        >
          {{ shortOfferTitle }}
        </h1>
        <h1 class="company">
          <span v-if="offer.companyHideName === 0 && offer && offer.user && offer.user.company && offer.user.company.title">
            {{ offer.user.company.title }}
          </span>
          <span
            v-if="offer.companyHideName === 1"
            style="color: #666; text-transform: initial; font-size: 0.8rem;"
          >
            {{ $t('cards.offer-employer.no-company-name', 'No company name') }}
          </span>
        </h1>
      </div>

      <div class="col-12 col-md-1 column">
        <div
          v-if="offer.isArchived"
          style="font-size: 0.8rem; color: #b74d4d;line-height: 0.5rem;"
        >
          {{ $t('cards.offer-employer.status.archived', 'Archived') }}
        </div>
        <div
          v-else-if="!offer.isPaid"
          style="font-size: 0.8rem; color: #ffbc00;line-height: 0.5rem;"
        >
          {{ $t('cards.offer-employer.status.draft', 'Draft') }}
        </div>
        <div
          v-else
          style="font-size: 0.8rem; color: green;line-height: 0.5rem;"
        >
          {{ $t('cards.offer-employer.status.open', 'Open') }}
        </div>
      </div>

      <div class="col-12 col-md-2 column">
        <span class="sm-text">
          {{ shortDate }}
        </span>
      </div>

      <div class="col-12 col-md-2 column">
        <h1 class="municipality">
          {{ offer.locationProvince }}, {{ offer.locationMunicipality }} ( {{ offer.locationCountry }} )
        </h1>
      </div>

      <div
        class="col-12 col-md-3 column"
        style="padding: 0 45px;"
      >
        <div
          class="row"
          style="cursor: pointer;"
          @click="$router.push({ name: 'offer-candidates', query: { offer: offer.id } })"
        >
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-new' + offer.id">
                {{ $t('cards.offer-employer.candidate.new', 'New') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-new' + offer.id"
                class="mr-2 icon"
                icon="eye-slash"
              />
            </div>
            <div class="row">
              {{ offersCount('New') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-seen' + offer.id">
                {{ $t('cards.offer-employer.candidate.seen', 'Seen') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-seen' + offer.id"
                class="mr-2 icon"
                icon="hourglass"
              />
            </div>
            <div class="row">
              {{ offersCount('Seen') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-inprocess' + offer.id">
                {{ $t('cards.offer-employer.candidate.inprocess', 'In process') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-inprocess' + offer.id"
                class="mr-2 icon"
                icon="tasks"
              />
            </div>
            <div class="row">
              {{ offersCount('In process') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-accepted' + offer.id">
                {{ $t('cards.offer-employer.candidate.accepted', 'Accepted') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-accepted' + offer.id"
                class="mr-2 icon"
                icon="user-check"
              />
            </div>
            <div class="row">
              {{ offersCount('Accepted') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-rejected' + offer.id">
                {{ $t('cards.offer-employer.candidate.rejected', 'Rejected') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-rejected' + offer.id"
                class="mr-2 icon"
                icon="user-times"
              />
            </div>
            <div class="row">
              {{ offersCount('Rejected') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-invalid' + offer.id">
                {{ $t('cards.offer-employer.candidate.invalid', 'Not valid') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-invalid' + offer.id"
                class="mr-1 icon"
                icon="user-slash"
              />
            </div>
            <div
              class="row"
              style="margin-left: -10px;"
            >
              {{ offersCount('Invalid') }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-2 column">
        <div
          class="sm-text"
        >
          <b-dropdown
            id="dropdown-1"
            :text="$t('generic.actions', 'Actions')"
            size="sm"
            class="m-md-2"
          >
            <b-dropdown-item
              v-if="offer.isPaid"
              class="p-0"
              @click.stop="$router.push({ path: '/jobs/offer/' + offer.id + '/' + generateSlug })"
            >
              {{ $t('cards.offer-employer.actions.view', 'View') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('jobs_manage') && !offer.isArchived"
              class="p-0"
              @click="$emit('editOffer', offer)"
            >
              {{ $t('cards.offer-employer.actions.edit', 'Edit') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('jobs_manage') && !offer.isArchived && offer.isPaid"
              class="p-0"
              @click="$emit('archiveOffer', offer)"
            >
              {{ $t('cards.offer-employer.actions.archive', 'Archive') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="offer.isPaid"
              class="p-0"
              @click.self="$router.push({ name: 'offer-candidates', query: { offer: offer.id } })"
            >
              {{ $t('cards.offer-employer.actions.view-candidates', 'View candidates') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="offer.is_internship && offer.isPaid"
              class="p-0"
              @click.self="$router.push({ name: 'offer-interns', query: { offer: offer.id } })"
            >
              {{ $t('cards.offer-employer.actions.view-interns', 'View interns') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('jobs_manage') && (offer.isArchived || offer.isPaid)"
              class="p-0"
              @click="$emit('copyOffer', offer)"
            >
              {{ $t('cards.offer-employer.actions.copy', 'Copy') }}
            </b-dropdown-item>
            <div :id="'multiprovincia' + offer.id">
              <b-dropdown-item
                v-if="$can('jobs_manage') && offer.isPaid"
                class="p-0"
                :disabled="offer.locationCountry != 'España' || offer.isPaid != true || offer.isArchived === true"
                @click="$emit('multiprovince', offer)"
              >
                <span
                  :style="offer.locationCountry != 'España' ? 'color: gray' : ''"
                >
                  {{ $t('cards.offer-employer.actions.multiprovince', 'Multi province') }}
                </span>
                <b-tooltip
                  v-if="offer.locationCountry != 'España'"
                  :target="'multiprovincia' + offer.id"
                  triggers="hover"
                  variant="danger"
                >
                  {{ $t('cards.offer-employer.actions.multiprovince.only-in-spain', 'Only in spain!') }}
                </b-tooltip>
                <b-tooltip
                  v-if="offer.isPaid != true || offer.isArchived === true"
                  :target="'multiprovincia' + offer.id"
                  triggers="hover"
                  variant="danger"
                >
                  {{ $t('cards.offer-employer.actions.multiprovince.only-active-offers', 'Only active offers!') }}
                </b-tooltip>
              </b-dropdown-item>
            </div>
            <b-dropdown-item
              v-if="$can('jobs_manage') && !offer.isPaid"
              class="p-0"
              @click="$emit('destroy', offer)"
            >
              {{ $t('cards.offer-employer.actions.destroy', 'Destroy') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('jobs_manage') && (!offer.isArchived && offer.isPaid)"
              class="p-0"
              @click="$emit('shareOffer', offer)"
            >
              {{ $t('cards.offer-employer.actions.share', 'Share') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div> <!-- /row -->
  </div>
</template>

<script>
export default {
  props: {
    offer: {
      type: Object,
      default: null
    }
  },
  computed: {
    generateSlug() {
      let slug = this.offer.titleTitle.replace(/[^A-Z0-9]+/ig, "-").toLowerCase()  +
        '/' + this.offer.locationProvince.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
      return slug;
    },
    shortDate() {
      return this.offer.created_at.substring(0, 10);
    },
    shortOfferTitle() {
      let title = this.offer.titleTitle.substring(0,25);
      if(this.offer.titleTitle.length > 25) {
        title += "...";
      }
      return title;
    }
  },
  methods: {
    mysqlTimeStampToDate(timestamp) {
      //function parses mysql datetime string and returns javascript Date object
      //input has to be in this format: 2007-06-05 15:26:02
      var regex=/^([0-9]{2,4})-([0-1][0-9])-([0-3][0-9]) (?:([0-2][0-9]):([0-5][0-9]):([0-5][0-9]))?$/;
      var parts=timestamp.replace(regex,"$1 $2 $3 $4 $5 $6").split(' ');
      return new Date(parts[0],parts[1]-1,parts[2],parts[3],parts[4],parts[5]);
    },
    offersCount(status) {
      let count = 0;
      for(let offer of this.offer.offer_applies){
        if(offer.status === status) {
          count++;
        }
      }
      return count;
    }
  }
}
</script>


<style scoped lang="scss">
  .offer-card {
    background: white;
    padding: 15px 25px;
    margin-bottom: 0.5rem;
    transition: 0.2s ease;

    .internship-cap {
      position: absolute;
      transform: translate(-30px, -20px);
    }

    &:hover {
      box-shadow: 3px 3px 20px 0px rgba(210,210,210,1);
    }
  }

  h1.title {
    color: #999;
    font-size: 1rem !important;
    margin-bottom: 0;
    cursor: pointer;
  }

  h1.company {
    color: #009090;
    font-size: 0.7rem !important;
    text-transform: uppercase;
  }

  h1.municipality {
    color: #777;
    font-size: 0.8rem !important;
  }

  .sm-text {
    font-size: 0.9rem;
    color: #666;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .expired-offer {
    background: #f1ebeb;
    border: 1px solid white;
  }

  .column {
    margin: auto;
  }

  .card-wrapper {
    flex-direction: row;

    @media screen and (max-width: 767px) {
      & {
        flex-direction: column;
      }

      .column {
        text-align: left;
      }
    }
  }

  .icon {
    cursor: pointer;
  }
</style>
